import React from "react";

interface CaretDownIconProps {
  color?: string;
  className?: string;
}

export const CaretDownIcon: React.FC<CaretDownIconProps> = ({
  color,
  className,
}) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.99942 6.02112C5.8789 6.02112 5.76673 6.00189 5.66289 5.96342C5.55904 5.92496 5.46032 5.85893 5.36674 5.76535L0.872517 1.27112C0.73405 1.13267 0.663217 0.958642 0.660017 0.749025C0.6568 0.539408 0.727634 0.362166 0.872517 0.217299C1.01738 0.0724322 1.19302 0 1.39942 0C1.60582 0 1.78145 0.0724322 1.92632 0.217299L5.99942 4.2904L10.0725 0.217299C10.211 0.0788489 10.385 0.00801556 10.5946 0.00479889C10.8042 0.00159889 10.9814 0.0724322 11.1263 0.217299C11.2712 0.362166 11.3436 0.537808 11.3436 0.744225C11.3436 0.950625 11.2712 1.12626 11.1263 1.27112L6.63209 5.76535C6.53851 5.85893 6.43979 5.92496 6.33594 5.96342C6.23211 6.00189 6.11993 6.02112 5.99942 6.02112Z"
        fill={color ?? "currentColor"}
      />
    </svg>
  );
};
